// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2_LFA","signatureButtonsRight":"ModalSign_signatureButtonsRight__3vcry"};